// extracted by mini-css-extract-plugin
export default {"wrapper":"Create_wrapper__-K2WO","col":"Create_col__GOl9e","formSelect":"Create_formSelect__3cvLx","reset_form_style":"Create_reset_form_style__e7AdY"};